import NavigationService from '@ajs/services/NavigationService';
import { Component, OnInit, inject } from '@angular/core';

@Component({
    selector: 'fdx-logout',
    template: '',
    standalone: true
})
export class LogoutComponent implements OnInit {
    private readonly navigationService: NavigationService = inject(NavigationService);

    ngOnInit(): void {
        this.navigationService.redirectToLogin();
    }
}
